import React, { useState, useEffect } from "react"
import { useSelector, useDispatch } from "react-redux"
import { signIn, ecpSignIn } from "../ducks/profile"
import { takeUserAuthData } from "../ducks/userAuthData"
import { useTranslation } from "react-i18next"
import { isEmpty } from "ramda"
import ECPcomponent from "./ECPcomponent"
import { useHistory } from "react-router-dom"
import { Input, Button } from "semantic-ui-react"

const LoginComponent = (props) => {
  const [login, setLogin] = useState("")
  const [iinOrBin, setIinOrBin] = useState("")
  const [pass, setPass] = useState("")
  const [x509, setX509] = useState("")
  const [loginError, setLoginError] = useState(false)
  const [passError, setPassError] = useState(false)
  const [isLoading, setIsLoading] = useState(false)
  const { t } = useTranslation()
  const history = useHistory()
  const dispatch = useDispatch()
  const profile = useSelector((state) => state.profile)
  const onSignIn = (...data) => {
    dispatch(signIn(...data))
  }
  const onEcpSignIn = (...data) => {
    dispatch(ecpSignIn(...data))
  }
  const onTakeUserAuthData = (...data) => {
    dispatch(takeUserAuthData(...data))
  }
  const signInCallback = () => {
    setIsLoading(false)
  }
  const handleSubmit = () => {
    if (isLoading) return
    const loginError = isEmpty(login)
    const passError = isEmpty(pass)
    setPassError(passError)
    setLoginError(loginError)
    if ((loginError, passError)) return
    setIsLoading(true)
    onSignIn(login, pass, signInCallback)
  }
  const submit = (lgn, x) => {
    onEcpSignIn(lgn, x, signInCallback)
  }
  const { ecpEntry } = props
  return (
    <>
      <div>
        {ecpEntry ? (
          <div>
            <ECPcomponent
              setX509={setX509}
              submit={submit}
              setIinOrBin={setIinOrBin}
            />
          </div>
        ) : (
          <div>
            <h4>{t("Login")}:</h4>
            <div>
              <Input
                fluid
                size="small"
                placeholder={t("Login")}
                onChange={(e, d) => {
                  setLogin(d.value)
                }}
              />
            </div>
            <h4 style={{ marginTop: 10 }}>{t("Password")}:</h4>
            <div>
              <Input
                fluid
                size="small"
                type="password"
                placeholder={t("Password")}
                onChange={(e, d) => {
                  setPass(d.value)
                }}
              />
            </div>
            <div
              style={{
                marginTop: 10,
                display: "flex",
                alignItems: "center",
                justifyContent: "flex-end",
              }}
            >
              <Button
                positive
                onClick={handleSubmit}
                content={t("Submit")}
                size="large"
              />
            </div>
          </div>
        )}
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            paddingLeft: 10,
            paddingRight: 10,
            paddingTop: 10,
            color: "#2c3854",
          }}
        >
          {t("Don't have an account yet ?")}
          <a
            onClick={() => {
              history.push("/registration")
            }}
            style={{ color: "#3090c7", marginLeft: 5 }}
          >
            {t("Register now")}
          </a>
        </div>
      </div>
    </>
  )
}

export default LoginComponent
